var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { LinkButton, Typography } from '@pinwheel/origami';
import { useOpts } from '../../../context';
import eventQueue from '../../../events/queue';
import useGetActionOnClick from './utils';
function ErrorAction(props) {
    var opts = useOpts();
    var action = props.action;
    var dataTestId = "action-".concat(action.actionType);
    var onClick = useGetActionOnClick(action);
    var child = action.actionType === 'payload' ? (React.createElement(LinkButton, { "data-testid": dataTestId, "aria-label": action.label, sx: props.style, onClick: function () {
            var _a;
            if (action.payload.account_recovery_step_key === 'account_recovery') {
                var newCheckpoints = new Set(opts.checkpoints);
                newCheckpoints.add('account_recovery');
                (_a = opts.setCheckpoints) === null || _a === void 0 ? void 0 : _a.call(opts, newCheckpoints);
            }
            eventQueue.emit('link_api_action', {
                action: action,
            });
            props.onSubmit(action.payload);
        } }, action.label)) : action.actionType === 'hyperlink' ? (React.createElement("a", { "data-testid": dataTestId, "aria-label": action.label, href: action.href, style: __assign({}, props.style), target: "_blank", rel: "noopener noreferrer" }, action.label)) : action.actionType === 'search' ? (React.createElement(LinkButton, { "data-testid": dataTestId, "aria-label": action.label, onClick: onClick }, action.label)) : action.actionType === 'callback' ? (React.createElement("span", { "data-testid": dataTestId, "aria-label": action.label, style: __assign(__assign({}, props.style), { cursor: 'pointer' }), onClick: onClick }, action.label)) : null;
    return (React.createElement(Typography, { variant: "caption", key: action.label, color: "light", sx: { textAlign: 'center' } }, child));
}
export default ErrorAction;
